import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopMosambee = dynamic(() => import("../../components/software-partners/MosambeePayments/DesktopMosambee"), {
    loading: () => <Loading />,
});

const MobileMosambee = dynamic(() => import("../../components/software-partners/MosambeePayments/MobileMosambee"), {
    loading: () => <Loading />,
});

const mosambeePayments = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>QueueBuster POS with Mosambee Payments Integration | Simplify Transactions</title>
                <meta name="description" content="Integrate QueueBuster POS with Mosambee Payments for secure and seamless transactions. Manage payments efficiently and enhance the customer experience." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/mosambee-payments" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/mosambee-payments" hrefLang="en-us" />
                <meta property="og:title" content="QueueBuster POS + Mosambee Payments: Streamlined Payment Solutions" />
                <meta property="og:description" content="Discover the power of QueueBuster POS and Mosambee Payments integration. Simplify transactions and deliver a smooth payment experience for your customers." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/Group+1171276126.png" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/mosambee-payments" />
            </Head>
            {mobileView ? <MobileMosambee /> : <DesktopMosambee />}
        </>
    )
}

export default mosambeePayments;




 